import {FC} from "react"
import {Box} from "@mui/material"

type Props = {
  separator: string
  distanceX: string
  fontSize?: string
  fontWeight?: string
  paddingTop?: string
}
const TextSeparator: FC<Props> = ({
  separator = "-",
  distanceX = "7px",
  fontSize = "",
  paddingTop = "",
  fontWeight = "",
}) => {
  return (
    <Box
      style={{
        marginLeft: distanceX,
        marginRight: distanceX,
        fontSize: fontSize,
        fontWeight: fontWeight,
        paddingTop: paddingTop,
      }}
    >
      {" "}
      {separator}
    </Box>
  )
}

export default TextSeparator
